import React from "react";
import "./Firstsec.css";
import { Button, Container } from "react-bootstrap";
import { TypeAnimation } from "react-type-animation";
import { useNavigate } from "react-router-dom";

const Firstsec = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="first-sec">
        <Container>
          <div className="bg_img" />
          <h2 className="text-data">
            Founders trust our
            <br />
            <TypeAnimation
              sequence={["Technology", 1000]}
              speed={10}
              repeat={0}
              cursor={false}
              className="type first-text"
            />
            <span className="word">expertise</span>
            <br />
            <span className="word">for</span>
            <TypeAnimation
              sequence={["Innovative Solutions", 1000]}
              speed={10}
              repeat={0}
              cursor={false}
              className="type last-text"
            />
          </h2>

          <p className="paragraph-content">
            With a decade of trustworthy experience we help ambitious businesses
            by providing technology support.
          </p>

          <div className="btn-parent">
            <Button
              variant="light data-btn sBtn1"
              onClick={() => navigate("/portfolio")}
            >
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M6.66797 10.166H12.5013"
                  stroke="var(--primary-color)"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M6.66797 13.5H10.318"
                  stroke="var(--primary-color)"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M8.33464 4.99935H11.668C13.3346 4.99935 13.3346 4.16602 13.3346 3.33268C13.3346 1.66602 12.5013 1.66602 11.668 1.66602H8.33464C7.5013 1.66602 6.66797 1.66602 6.66797 3.33268C6.66797 4.99935 7.5013 4.99935 8.33464 4.99935Z"
                  stroke="var(--primary-color)"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M13.3333 3.34961C16.1083 3.49961 17.5 4.52461 17.5 8.33294V13.3329C17.5 16.6663 16.6667 18.3329 12.5 18.3329H7.5C3.33333 18.3329 2.5 16.6663 2.5 13.3329V8.33294C2.5 4.53294 3.89167 3.49961 6.66667 3.34961"
                  stroke="var(--primary-color)"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <span>View case study</span>
            </Button>{" "}
            <Button
              variant="outline-light data-btn sBtn2"
              onClick={() => navigate("/ContactUs")}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill=""
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.64861 5.84078L5.38673 6.85398C6.18314 8.47632 7.5022 9.79539 9.12501 10.5923L10.1581 9.33132C10.3618 9.07867 10.7134 8.99125 11.0129 9.12097L13.5559 10.2111C13.8617 10.372 14.061 10.7282 13.9813 11.0704L13.4363 13.4329C13.3598 13.7669 13.0663 14.0005 12.7224 14.0005C6.80939 14.0001 2.00001 9.1907 2.00001 3.27742C2.00001 2.93382 2.23366 2.63992 2.56767 2.56375L4.93017 2.01882C5.27423 1.93909 5.62579 2.11768 5.76876 2.44351L6.85907 4.98648C6.98653 5.28601 6.90056 5.635 6.64861 5.84078ZM4.63759 0.752177C5.59998 0.529808 6.56908 1.03207 6.9592 1.92116L6.96361 1.93121L8.05529 4.47748C8.40897 5.30868 8.17129 6.27563 7.47095 6.84763L7.46255 6.85449L7.07407 7.16635C7.54654 7.8477 8.13941 8.43962 8.82176 8.91116L9.1501 8.51043C9.72032 7.80758 10.6931 7.5673 11.5267 7.92682C11.5277 7.92723 11.5286 7.92764 11.5296 7.92805L14.1155 9.03652L14.1611 9.06053C14.8987 9.44853 15.4827 10.3514 15.2477 11.3637C15.2476 11.3642 15.2475 11.3647 15.2474 11.3652L14.7035 13.7233C14.7034 13.7238 14.7033 13.7242 14.7032 13.7246C14.7031 13.7248 14.7032 13.7245 14.7032 13.7246C14.4902 14.6502 13.6699 15.3005 12.7224 15.3005C6.0915 15.3 0.700012 9.90867 0.700012 3.27742C0.700012 2.33106 1.34919 1.50919 2.27667 1.29673L4.63759 0.752177Z"
                />
              </svg>

              <span>Get A Free Quote</span>
            </Button>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Firstsec;
